import { Button, Text } from "@chakra-ui/react";
import React from "react";

import { downloadFile } from "@nens/shared-utils";

const ExplainExcelMeasuringpoint: React.FC = () => {
  return (
    <>
      <Text pb="5">
        Gebruik deze optie om een bulk buizen aan een bestaand Meetnet (GMN) te koppelen. Zorg
        ervoor dat u het format in het volgende template hanteert. Voor het eventType, het
        gebeurtenis type, kan zowel de Nederlandse als Engelse benaming worden gebruikt. U heeft
        keuze uit de drie beschikbare bericht-types: MeetpuntToevoegen, MeetpuntEindDatum en
        BuisReferentie:
      </Text>
      <Button
        mb={4}
        variant="primary"
        onClick={() =>
          downloadFile(
            "/files/gmnAddMeasuringPointsExcelTemplate.xlsx",
            "veranderMeetnetSamenstellingExcelTemplate.xlsx"
          )
        }
      >
        Download Excel-template
      </Button>
      <Button
        variant="primary"
        onClick={() =>
          downloadFile(
            "/files/gmnAddMeasuringPointsCSVTemplate.csv",
            "veranderMeetnetSamenstellingCSVTemplate.csv"
          )
        }
      >
        Download CSV-template
      </Button>
    </>
  );
};

export { ExplainExcelMeasuringpoint };
